import StarsRateIcon from '@/components/icons/StarsRateIcon';
import { formatDateString } from '@/utils/global';
import { useLocale } from 'next-intl';

// Sorting by rate Value 5,4,3,2,1 and so on

// function sortReviewsByRating(reviewsArray) {
//   const sortedReviews = [...reviewsArray];
//   sortedReviews.sort((a, b) => {
//     const ratingA = a.ratings[0]?.value || 0;
//     const ratingB = b.ratings[0]?.value || 0;
//     return ratingB - ratingA;
//   });

//   return sortedReviews;
// }

const Comments = ({ reviews = [] }) => {
  const locale = useLocale();
  // const ratingScore = reviews?.length
  //   ? (
  //       reviews
  //         ?.map((r) => r?.ratings?.[0]?.value || 5)
  //         .reduce((a, b) => a + b) / reviews?.length
  //     ).toFixed(2)
  //   : 0;

  return (
    <div className='rounded-lg bg-gray-100 p-3.5 max-sm:p-1.5'>
      {reviews
        ?.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        })
        ?.map((comment, index) => (
          <div
            key={index}
            className='mb-2 flex gap-10 border-b-2 border-gray-200 py-2 last:mb-0 last:border-b-0'
          >
            <div className='flex flex-col gap-3 max-lg:max-w-[110px] max-lg:min-w-[110px] max-lg:gap-1.75 max-sm:max-w-[90px] max-sm:min-w-[90px] max-sm:gap-1 lg:max-w-[126px] lg:min-w-[126px]'>
              <span className='font-bold text-nowrap max-lg:text-sm max-sm:text-[10px] lg:text-sm'>
                {comment?.nickname}
              </span>
              <StarsRateIcon
                className='max-lg:w-20 max-sm:w-16'
                // rate={ratingScore || 4.7}
                rate={comment?.ratings?.[0]?.value || 4.7}
              />
              <span className='text-sm text-gray-500 max-sm:text-xs max-sm:text-[9px]'>
                {formatDateString(comment?.created_at, locale)}
              </span>
            </div>
            <p className='text-gray-700 max-lg:text-xs max-sm:px-2 max-sm:text-[9px] md:px-10 lg:text-[13px]'>
              {comment?.detail}
            </p>
          </div>
        ))}
    </div>
  );
};

export default Comments;
